import React from 'react';
import { SupportsPanel } from './supports/SupportsPanel';
import { OrientationPanel } from './OrientationPanel';
import { LayoutPanel } from './LayoutPanel';
import { HollowPanel } from './HollowPanel';
import { TexturePanel } from './texture/TexturePanel';
import { LabelPanel } from './LabelPanel';
import { DrillHolePanel } from './DrillHolePanel';
import { SizePanel } from './SizePanel';
import { OneClickPanel } from './OneClickPanel';
import { ProtectPanel } from './protect/ProtectPanel';
import type { SupportState, ToolId } from '../../types/tools';
import type { PrepareStep } from '../../types/prepare';
import type { ProtectAiResult, ProtectSettings } from '../../types/protect';
export type ProtectPanelBindings = {
  settings: ProtectSettings;
  onSettingsChange: (settings: ProtectSettings) => void;
  onDone: () => void;
  onDeselectAll: () => void;
  onRunAi: () => void;
  aiResult: ProtectAiResult | null;
};
type ToolPanelProps = {
  tool: ToolId;
  onClose: () => void;
  supportState: SupportState;
  prepareStep: PrepareStep;
  touchpoints: number;
  onPrepareAll: () => void;
  onGenerate: () => void;
  onClear: () => void;
  onAutoOrient: () => void;
  onManualChange: (manual: boolean) => void;
  protect: ProtectPanelBindings;
};
export function ToolPanel({
  tool,
  onClose,
  supportState,
  prepareStep,
  touchpoints,
  onPrepareAll,
  onGenerate,
  onClear,
  onAutoOrient,
  onManualChange,
  protect
}: ToolPanelProps) {
  switch (tool) {
    case 'oneclick':
      return <OneClickPanel onClose={onClose} supportState={supportState} prepareStep={prepareStep} touchpoints={touchpoints} onRun={onPrepareAll} data-id="element-756" data-mp="1fidvnixiiwb4" />;
    case 'size':
      return <SizePanel onClose={onClose} data-id="element-757" data-mp="11kxtijm91op6" />;
    case 'protect':
      return <ProtectPanel onClose={onClose} {...protect} data-id="element-758" data-mp="16iqv0zclxuj4" />;
    case 'orient':
      return <OrientationPanel onClose={onClose} onAutoOrient={onAutoOrient} busy={supportState === 'generating'} data-id="element-759" data-mp="2vwm8glshdr9k" />;
    case 'support':
      return <SupportsPanel onClose={onClose} supportState={supportState} onGenerate={onGenerate} onClear={onClear} onManualChange={onManualChange} data-id="element-760" data-mp="30v7besz4ap1p" />;
    case 'layout':
      return <LayoutPanel onClose={onClose} data-id="element-761" data-mp="2uenkq0a7iv64" />;
    case 'hollow':
      return <HollowPanel onClose={onClose} data-id="element-762" data-mp="2pglzp9t80ls0" />;
    case 'texture':
      return <TexturePanel onClose={onClose} data-id="element-763" data-mp="2pgvudap7nh41" />;
    case 'label':
      return <LabelPanel onClose={onClose} data-id="element-764" data-mp="2kikjcwn6j0k8" />;
    case 'hole':
      return <DrillHolePanel onClose={onClose} data-id="element-765" data-mp="3i5b4pjxedb91" />;
  }
}